import keepAlive from 'lib/keep-alive';

var ProgressService = function () {
  this.saveProgress = function (model, page, cb) {
    var data;
    cb = cb || function () {};

    if (page instanceof EF.Models.ContentPage) {
      data = {
        key: page.key,
        page_key: page.key,
        completed: page.completed,
        data: page.pageData,
        activity_key: page.activityKey,
        module_key: page.moduleKey,
        date: new Date(),
      };
    } else if (page instanceof EF.Models.Page) {
      data = {
        key: page.get('key'),
        page_key: page.get('key'),
        completed: page.get('completed'),
        data: page.pageData,
        activity_key: page.activity.get('key'),
        module_key: page.activity.module.get('key'),
        date: new Date(),
      };
    }
    data.content_id = EF.enrollment.get('contentId');

    model.savePage(page, data, cb);

    keepAlive();
  };

  this.getPath = function (eid) {
    return `/progress/${eid}/page_progress`;
  };

  this.getRequestOptions = function (request) {
    var data = {
      data: {
        type: 'page_progress',
        attributes: request.data,
      },
    };

    var options = {
      type: 'POST',
      url: request.url,
      headers: {
        Authorization: `Bearer ${EF.config.get('accessToken')}`,
        'Content-Type': 'application/vnd.api+json',
      },
      processData: false,
      data: JSON.stringify(data),
    };

    return options;
  };

  this.saveActivityProgress = function (model, grade, attempt, slug) {};

  this.saveCourseTimeProgress = function ({ intervalSeconds }) {
    if (
      (!EF.enrollment && !EF.enrollment.get('id')) ||
      (!EF.config && !EF.config.get('basePath')) ||
      (!EF.enrollment && !EF.enrollment.get('contentId'))
    ) {
      return;
    }
    const progressId = EF.enrollment.get('id');
    const basePath = EF.config.get('basePath');
    const contentId = EF.enrollment.get('contentId');
    const url = `${basePath}/progress/${progressId}/time_log`;

    return fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache',
        Authorization: `Bearer ${EF.config.get('accessToken')}`,
      },
      body: 
        JSON.stringify({
          data: {
            id: progressId,
            type: 'progress',
            attributes: {
              type: 'content',
              content_id: contentId,
              duration: `PT${intervalSeconds}S`,
            },
          },
        })
    });
  };
};

module.exports = new ProgressService();
